import React, { useState, useEffect } from 'react';
import { R } from '../routes';

const html_has_text = (html) => {
	const tmp = document.createElement("div");
	tmp.innerHTML = html;
	return tmp.innerText.trim().length > 0;
}


const GET = (url) => {
	return new Promise((resolve, reject) => {
		let xhr = new XMLHttpRequest();
		xhr.withCredentials = false;
		xhr.responseType = "text";
		xhr.onreadystatechange = () => {
			if (xhr.readyState !== 4) return;
			resolve({body: xhr.response, status: xhr.status});
		};
		xhr.open("GET", url);
		xhr.send();
	});
};

const BigTextInner = (props) => {
	const [ body, set_body ] = useState(null);
	const [ failed, set_failed ] = useState(false);
	const [ lang, set_lang ] = useState(props.lang);

	useEffect(() => {
		const url = "https://zwedit.s3.eu-north-1.amazonaws.com/b/aktiedysten/b." + props.k + "." + lang + ".html";
		GET(url).then(x => {
			if (x.status === 200) {
				if (html_has_text(x.body)) {
					set_body(x.body);
				} else {
					if (props.fallback_lang && lang !== props.fallback_lang) {
						set_lang(props.fallback_lang);
					}
				}
			} else {
				set_failed(true);
			}
		}).catch(e => {
			set_failed(true);
		});
	}, [lang, props.k]);

	let r = <span>...</span>; // XXX allow custom loader?
	if (failed) {
		r = <span data-error="could not fetch document"></span>; // XXX allow custom "not found" message?
	} else if (body !== null) {
		r = <div dangerouslySetInnerHTML={{__html:body}}></div>;
	}
	return r;
}


const BigText = (props) => {
	return <BigTextInner {...props} lang={R.get_current_language()}/>;
};

export default BigText;



// WEBPACK FOOTER //
// ./src/c/BigText.js